// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
/* eslint-disable @typescript-eslint/no-explicit-any */

import { createAxios } from 'ts/createAxios';
import { TTrucksResponse } from 'types/Collect';
import { getApiPath } from 'util/commons';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';

export const getTruckDrivers = async (params: {
  successCallback?: (data: TTrucksResponse) => void;
  failedCallback?: (error: any) => void;
}) => {
  const { successCallback, failedCallback } = params;

  try {
    const { data } = await createAxios().get(
      getApiPath(API_ENDPOINTS.TRUCKS_DRIVERS)
    );

    successCallback?.(data);
  } catch (e) {
    handleError(e);
    failedCallback?.(e);
  }
};
